// For the listbox, I DOWNLOADED the files from this repository:
// https://github.com/facuesr/react-multiselect-listbox
// and copied everything from the src folder from that project into a new folder inside the src folder of my project.
// at the beginning I installed the package as usual..
// but then I realised I had to do some changes and decided to just use the files
// without installing the package.
// The files however, require some libraries to work. You still need to install those.
//npm i sass
//npm i react-window
//npm i react-beautiful-dnd
//npm i react-virtualized-auto-sizer

import React, { memo, useState, useMemo, useCallback } from 'react'
import { DragDropContext } from 'react-beautiful-dnd'
import { defaultStrings } from './defaults'
// No need for the buttons..
//import Button from './components/Button'
import SelectedListHeader from './components/SelectedListHeader'
import OptionListHeader from './components/OptionListHeader'
import ListBox from './components/ListBox'
import styles from './styles.module.scss'

const MultiSelectListBox = ({
  overrideStrings = defaultStrings,
  boxHeight = 175,
  rowHeight = 25,
  textField = 'text',
  valueField = 'value',
  sortable,
  alloptions,
  value,
  onSelect,
  onRemove,
  onSelectAll,
  onRemoveAll,
  onSort,
  onSearch
}) => {
  const { search, selectAll, removeAll, selectedInfo } = overrideStrings
  const [query, setQuery] = useState('')

  const availableOptions = useMemo(() => {
    const items = alloptions.filter((item) => !value.includes(item[valueField]));
    return onSearch
      ? onSearch({
          items,
          query,
          textField,
        })
      : items.filter((item) => item[textField].toUpperCase().includes(query.toUpperCase()));
  }, [alloptions, query, textField, value, valueField, onSearch]);

  const selectedOptions = useMemo(
    () =>
    alloptions
        .filter(item => value.includes(item[valueField]))
        .sort(
          (a, b) => value.indexOf(a[valueField]) - value.indexOf(b[valueField])
        ),
    [alloptions, value, valueField]
  )

  //const handleSelectAll = useCallback(() => {
  //  if (onSelectAll) {
  //    onSelectAll([...availableOptions])
  //    setQuery('')
  //  }
  //}, [availableOptions, onSelectAll])

  const onItemAdd = useCallback(
    (item, sortedList) => {
      if (!sortedList) {
        sortedList = selectedOptions.slice()
        sortedList.push(item)
      }
      onSelect && onSelect({ item, sortedList })
    },
    [onSelect, selectedOptions]
  )

  const onItemRemove = useCallback(
    item => {
      onRemove && onRemove({ item })
    },
    [onRemove]
  )

  const onDragEnd = useCallback(
    result => {
      const { source, destination } = result
      if (
        destination &&
        source &&
        source.droppableId !== destination.droppableId
      ) {
        const item = availableOptions[source.index]
        const sortedList = selectedOptions.slice()
        sortedList.splice(destination.index, 0, item)
        onItemAdd(item, sortedList)
        return
      }
      if (!result.destination) {
        return
      }

      const sortedList = selectedOptions.slice()
      const [item] = sortedList.splice(source.index, 1)
      sortedList.splice(destination.index, 0, item)
      onSort && onSort({ sortedList })
    },
    [availableOptions, onItemAdd, onSort, selectedOptions]
  )

  return (
    <div className={`${styles.root}`}>
      <DragDropContext onDragEnd={onDragEnd}>
        <ListBox
          id={'options'}
          height={boxHeight}
          rowHeight={rowHeight}
          textField={textField}
          valueField={valueField}
          data={availableOptions}
          onItemClick={onItemAdd}
          sortable={sortable}
        >
          <OptionListHeader
            searchPlaceHolder={search}
            query={query}
            onQueryChange={e => setQuery(e.target.value)}
            //actionButton={
            //  <Button onClick={handleSelectAll} type="add">
            //    {selectAll}
            //  </Button>
            //}
          />
        </ListBox>
        <ListBox
          id={'selected'}
          height={boxHeight}
          rowHeight={rowHeight}
          textField={textField}
          valueField={valueField}
          data={selectedOptions}
          //data = {[1,2]}
          onItemClick={onItemRemove}
          sortable={sortable}
        >
          <SelectedListHeader
            count={value.length}
            label={selectedInfo}
            //actionButton={
            //  <Button onClick={onRemoveAll} type="remove">
            //    {removeAll}
            //  </Button>
            //}
          />
        </ListBox>
      </DragDropContext>
    </div>
  )
}

export default memo(MultiSelectListBox)
